const INITIAL_STATE = {}

const orderReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                // case "GET_DATA_TODOS_ORDER":
                //         return { ...state, todoslistaorder: action.payload.data }
                case "GET_DATA_ORDER":
                        return { ...state, listaOrder: action.payload.data }
                case "GET_DATA_STATUS":
                        return { ...state, listadataStatus: action.payload.data }
                case "GET_DATA_ITENS":
                        return { ...state, listaItensPdd: action.payload.data }
                // case "GET_DATA_PAYLOAD":
                //         return { ...state, listaPayLoad: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                default:
                        return state
        }
}
export default orderReducer;


